import { Card, Tabs, TabsProps } from 'antd'
import { FormInstance } from 'antd/lib'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GeneralServices, Laboratory } from './components'
import { useStyles } from './styles'

type Props = {
  form: FormInstance
}

enum TabKeys {
  General = 'general',
  Laboratory = 'laboratory'
}

export const InstitutionServices = ({ form }: Props) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  const [currentTab, setCurrentTab] = useState(TabKeys.General)

  const tabItems: TabsProps['items'] = [
    {
      key: TabKeys.General,
      label: t('epidemiology.general'),
      children: <GeneralServices />
    },
    {
      key: TabKeys.Laboratory,
      label: t('organizational_structure.lab'),
      children: <Laboratory form={form} />
    }
  ]

  return (
    <Card
      title={t('organizational_structure.services')}
      className={`full-width ${styles.institutionCard}`}
    >
      <Tabs
        items={tabItems}
        activeKey={currentTab}
        onChange={(key) => setCurrentTab(key as TabKeys)}
      />
    </Card>
  )
}
